// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios';
import VueAxios from 'vue-axios'
import $ from 'jquery'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/js/bootstrap.min'
import 'babel-polyfill'
import moment from 'moment'
moment.locale('zh-cn');

import BaiduMap from 'vue-baidu-map'
Vue.use(BaiduMap, {
  ak: 'oPRRhz4UlySplCSYF8EesOTjuaKShDlo'
})

import './assets/load'

Vue.config.productionTip = false

import 'animate.css'

Vue.use(ElementUI);
Vue.use(VueAxios, axios)
Vue.prototype.$moment = moment





router.beforeEach((to, from, next) => {
  if(to.name === 'PreviewNews'){
    next()
  }else if(to.name === undefined || to.name==='' || to.name===null){
    next('/page404');
  }else {
    next();
  }
})
axios.interceptors.response.use((response) => {
  // console.log(response)
  if (response.status === 200) {
    return response.data
  }
}, (err) => {
  return Promise.reject(err)
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js